export default __webpack_public_path__ + "static/media/gas.9882f211.png";